import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthProvider from './context/AuthContext';
import PostProvider from './context/PostContext';
import ChatProvider from './context/ChatContext';

// Auth pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import GoogleCallback from './pages/auth/GoogleCallback';

// Main pages
import Home from './pages/Home';
import Profile from './pages/Profile';
import EditProfile from './pages/EditProfile';
import Post from './pages/Post';
import Communities from './pages/Communities';
import CommunitiesOld from './pages/Communitiesold';
import CommunityDetail from './pages/CommunityDetail';
import Chat from './pages/Chat';
import Search from './pages/Search';
import Settings from './pages/Settings';
import NotFound from './pages/NotFound';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';

// Auth guard for protected routes
import AuthGuard from './components/auth/AuthGuard';
import MainLayout from './components/layout/Main';
import { DiscoverPage } from './pages/DIscover';
import { CommunityDashboardPage } from './components/comm/CommunityDashboard';
import { CommunityDashboardLayout } from './components/layout/CommunityDashboard';
import About from './pages/About';
import { MyCommunitiesPage } from './pages/MyCommunities';
import CommunityProvider, { CommunityContext } from './context/CommunityContext';
import { CommunityHomepage } from './components/comm/CommunityHomepage';
import { CommunityMembersPage } from './components/comm/CommunityMemberspage';
import { CommunityPostsPage } from './components/comm/CommunityPostsPage';
import { CommunityNewsletterPage } from './components/comm/CommunityNewsletterPage';
import { CommunityStorePage } from './components/comm/CommunityStorePage';
import Followers from './pages/Followers';
import CommunityPageBuilder from './components/comm/CommunityPageBuilder';

/**
 * Main App component with routing
 * @returns {JSX.Element} App component
 */
const App = () => {
  return (
    <Router>
      <AuthProvider>
        <PostProvider>
          <ChatProvider>
            <MainLayout>
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/about" element={<About />} />
              <Route path="/register" element={<Register />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/search" element={<Search />} />
              <Route path="/posts/:postId" element={<Post />} />
              <Route path="/profile/:username" element={<Profile />} />
              <Route path="/profile/:username/followers" element={<Followers />} />
              <Route path="/profile/:username/following" element={<Followers />} />
              {/* <Route path="/communities" element={<Communities />} /> */}
              <Route path="/communities/discover" element={<DiscoverPage />} />
              <Route path="/communities/my-communities" element={<MyCommunitiesPage />} />
              <Route path="/communitiesold" element={<CommunitiesOld />} />
              <Route path="/communities/:slug" element={<CommunityProvider><CommunityDashboardLayout><CommunityDashboardPage /></CommunityDashboardLayout></CommunityProvider>} />
              <Route path="/communitiesold/:slug" element={<CommunityDetail />} />

              <Route path="/communities/:slug/*" element={
                <CommunityProvider>
                  <CommunityDashboardLayout>
                    <Routes>
                      <Route path="/" element={<CommunityDashboardPage />} />
                      <Route path="home" element={<CommunityHomepage />} />
                      <Route path="members" element={<CommunityMembersPage />} />
                      <Route path="posts" element={<CommunityPostsPage />} />
                      <Route path="updates" element={<CommunityNewsletterPage />} />
                      <Route path="analytics" element={<CommunityHomepage />} />
                      <Route path="store" element={<CommunityStorePage />} />
                      <Route path="site-builder" element={<CommunityPageBuilder />} />
                    </Routes>
                  </CommunityDashboardLayout>
                </CommunityProvider>
              } />


              {/* Google Auth Callback Route */}
              <Route path="/auth/callback" element={<GoogleCallback />} />

              {/* Protected routes */}
              <Route
                path="/edit-profile"
                element={
                  <AuthGuard>
                    <EditProfile />
                  </AuthGuard>
                }
              />
              <Route
                path="/chat"
                element={
                  <AuthGuard>
                    <Chat />
                  </AuthGuard>
                }
              />
              <Route
                path="/chat/:userId"
                element={
                  <AuthGuard>
                    <Chat />
                  </AuthGuard>
                }
              />
              <Route
                path="/settings"
                element={
                  <AuthGuard>
                    <Settings />
                  </AuthGuard>
                }
              />

              {/* Not found route */}
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<Navigate to="/404" replace />} />
            </Routes>
            </MainLayout>
          </ChatProvider>
        </PostProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;